module.exports = __webpack_public_path__ + "images/accents/signature@1x-d49f14bad9402b8ce3a6517d3bfb6a1b.webp";